import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledLogo = styled(Box)`
  position: absolute;
  z-index: 2000;
  transform: translateX(-50%);
  width: var(--logo-m);
  height: var(--logo-m);

  ${props => props.theme.breakpoints.up('lg')} {
    width: var(--logo);
    height: var(--logo);
  }
`;

export const StyledGlow = styled(Box)`
  position: absolute;
  margin-top: 16px;
  border-radius: 50%;
  filter: blur(24px);
  width: var(--logo-m);
  height: var(--logo-m);
  background-color: var(--logo-glow-mobile);

  ${props => props.theme.breakpoints.up('lg')} {
    width: var(--logo);
    height: var(--logo);
    background-color: var(--logo-glow);
  }
`;
